import { defineComponent as _defineComponent } from 'vue'
import { computed } from "vue";
import { useVuetify } from "@/composition/useVuetify";
import { Chip } from "@/types/nj/Chip";


export default /*#__PURE__*/_defineComponent({
  __name: 'HierarchyChip',
  props: {
    chip: null
  },
  setup(__props: any) {

const props = __props as {
  chip: Chip;
};

const vuetify = useVuetify();



// Determine dynamic max length based on current Vuetify breakpoints.
// Adjust the logic if you are using Vuetify 3's useDisplay.
// This is a bit weird because we do three different types of visual layouts
// depending on the breakpoints.
const dynamicMaxLength = computed(() => {
  if (vuetify?.breakpoint?.xs) {
    return 30;
  } else if (vuetify?.breakpoint?.sm) {
    return 60;
  } else if (vuetify?.breakpoint?.md) {
    return 50;
  } else if (vuetify?.breakpoint?.lg) {
    return 20;
  } else {
    return 60;
  }
});

// Helper function to truncate a given string if it exceeds maxLen.
// This function keeps the first and last parts, separated by "..."
const truncateSegment = (str: string, maxLen: number) => {
  if (!str) return "";
  if (str.length <= maxLen) return str;
  // Reserve 3 characters for "..."
  const leftSide = Math.floor((maxLen - 3) / 2);
  const rightSide = maxLen - leftSide - 3;
  return str.slice(0, leftSide) + "..." + str.slice(-rightSide).trim();
};

const chip = computed(() => {
  const OFFICE_LABEL = "<b>Office</b>: ";
  const delimiter = ",";

  // if the chips we are analyzing is not an agency chip
  if (!props.chip.text.includes("&raquo;") && !props.chip.tooltip) {
    const split = props.chip.text.split(":");
    const label = split[0] + ": ";
    const textToTruncate = split[1];
    // double the dynamicMaxLength because we will only be truncating one
    // piece of text here
    if (textToTruncate.length >= dynamicMaxLength.value * 2) {
      return {
        ...props.chip,
        text:
          label + truncateSegment(textToTruncate, dynamicMaxLength.value * 2),
        tooltip: "<b>" + textToTruncate + "</b>",
      };
    }
    return props.chip;
  }
  // Get the full text and remove the constant prefix.
  let fullText = props.chip.text || "";
  let finalText = "";
  const guillemetToken = " &raquo; ";
  // Remove the label and work with the remainder.
  let agencies = fullText.slice(OFFICE_LABEL.length).split(delimiter);
  // if there is only one agency, don't add the guillemet token between them
  if (agencies.length > 1) {
    for (let i = 0; i < agencies.length; i++) {
      const agency = agencies[i];
      finalText += truncateSegment(agency, dynamicMaxLength.value);
      if (i < agencies.length - 1) {
        finalText += guillemetToken;
      }
    }
  } else {
    finalText = agencies.join("");
  }
  finalText = OFFICE_LABEL + finalText;
  return {
    ...props.chip,
    text: finalText,
  };
});

return { __sfc: true,vuetify, props, dynamicMaxLength, truncateSegment, chip }
}

})